(function () {
  /* ------------------------------------------------------------------
     v2 tri-mode toggle (studio / casual / runway).

     Cookie key stays `fc_casual` for in-place migration of v1 users.
     Legacy values map on read: 0 → studio, 1 → casual. Values written
     after v2 ships are the string mode names. Anything else
     (corrupt / future) falls back to the section's default mode.
  ------------------------------------------------------------------- */
  var COOKIE_NAME = 'fc_casual';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 9; // 9 days
  var VALID_MODES = ['studio', 'casual', 'runway'];
  var DEFAULT_MODE = 'studio';
  var root = document.documentElement;

  function readCookie() {
    var match = document.cookie.match(/(?:^|;\s*)fc_casual=([^;]+)/);
    if (!match) return null;
    var v = match[1];
    if (v === '0') return 'studio';
    if (v === '1') return 'casual';
    if (VALID_MODES.indexOf(v) !== -1) return v;
    return null;
  }

  function writeCookie(value) {
    document.cookie =
      COOKIE_NAME +
      '=' +
      value +
      '; path=/; max-age=' +
      COOKIE_MAX_AGE +
      '; samesite=lax';
  }

  function syncButtons(value) {
    var buttons = document.querySelectorAll('.casual-toggle__option');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute(
        'aria-pressed',
        buttons[i].getAttribute('data-value') === value ? 'true' : 'false'
      );
    }
  }

  /* PDP gallery reorder: casual_images render at the front of the
     viewer/thumbs in DOM order. When the visitor selects studio (or
     runway, which has no PDP equivalent — runway is collection-card-
     only by design), move casual items to the end so the variant
     featured_media is shown first. When the visitor selects casual,
     move them to the front. PDP gallery code itself is unchanged
     (out of scope for v2). */
  function applyPdpOrder(value) {
    var galleries = document.querySelectorAll('[data-pdp-gallery]');
    for (var g = 0; g < galleries.length; g++) {
      var lists = galleries[g].querySelectorAll('[data-pdp-viewer], [data-pdp-thumbs]');
      for (var l = 0; l < lists.length; l++) {
        var list = lists[l];
        var casualItems = list.querySelectorAll('[data-casual-item]');
        if (!casualItems.length) continue;
        if (value === 'casual') {
          for (var j = casualItems.length - 1; j >= 0; j--) {
            list.insertBefore(casualItems[j], list.firstChild);
          }
        } else {
          // studio or runway: casual at end
          for (var i = 0; i < casualItems.length; i++) {
            list.appendChild(casualItems[i]);
          }
        }
        var slides = list.children;
        for (var k = 0; k < slides.length; k++) {
          slides[k].classList.remove('is-active');
        }
        if (slides[0]) slides[0].classList.add('is-active');
      }
    }
  }

  // Apply mode to the page without persisting. Used during init so we
  // don't write a fresh cookie just because the visitor loaded the
  // page — only user interaction should persist a preference.
  function applyMode(value) {
    if (VALID_MODES.indexOf(value) === -1) value = DEFAULT_MODE;
    root.setAttribute('data-image-mode', value);
    syncButtons(value);
    applyPdpOrder(value);
  }

  // User interaction: apply + persist.
  function setMode(value) {
    if (VALID_MODES.indexOf(value) === -1) return;
    applyMode(value);
    writeCookie(value);
  }

  // Look for a toggle root on the page and pull its enabled-modes
  // list. Returns array of mode strings the active section permits.
  function readEnabledModesFromDom() {
    var root = document.querySelector('[data-casual-toggle-root][data-enabled-modes]');
    if (!root) return null;
    var raw = root.getAttribute('data-enabled-modes');
    if (!raw) return null;
    var modes = [];
    var parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p && VALID_MODES.indexOf(p) !== -1) modes.push(p);
    }
    return modes.length ? modes : null;
  }

  function readDefaultModeFromDom() {
    var root = document.querySelector('[data-casual-toggle-root][data-default-mode]');
    if (!root) return null;
    var v = root.getAttribute('data-default-mode');
    if (VALID_MODES.indexOf(v) !== -1) return v;
    return null;
  }

  function onClick(event) {
    var target = event.target;
    while (target && target !== document) {
      if (target.classList && target.classList.contains('casual-toggle__option')) {
        var value = target.getAttribute('data-value');
        if (VALID_MODES.indexOf(value) !== -1) setMode(value);
        return;
      }
      target = target.parentNode;
    }
  }

  /* ------------------------------------------------------------------
     Scroll-driven visibility for the floating pill (unchanged from v1).
  ------------------------------------------------------------------- */
  var REVEAL_THRESHOLD = 200;
  var TOP_THRESHOLD = 100;
  var DIRECTION_DEADZONE = 2;
  var lastScrollY = 0;
  var scrollTicking = false;

  function updateFloatingVisibility() {
    var y = window.scrollY || window.pageYOffset || 0;
    var delta = y - lastScrollY;
    var pills = document.querySelectorAll('.casual-toggle-floating[data-scroll-behavior]');
    for (var i = 0; i < pills.length; i++) {
      var pill = pills[i];
      var mode = pill.getAttribute('data-scroll-behavior');
      if (mode === 'always') {
        pill.classList.add('is-visible');
        continue;
      }
      var visible = pill.classList.contains('is-visible');
      if (mode === 'reveal_on_scroll_down') {
        if (y > REVEAL_THRESHOLD) visible = true;
        else if (y <= TOP_THRESHOLD) visible = false;
      } else if (mode === 'reveal_on_scroll_up') {
        if (y <= TOP_THRESHOLD) visible = false;
        else if (delta < -DIRECTION_DEADZONE) visible = true;
        else if (delta > DIRECTION_DEADZONE) visible = false;
      }
      pill.classList.toggle('is-visible', visible);
    }
    lastScrollY = y;
  }

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      updateFloatingVisibility();
      scrollTicking = false;
    });
  }

  function init() {
    // Resolution chain: cookie value → section's default-mode →
    // DEFAULT_MODE (studio). The cookie reader migrates legacy 0/1
    // values to studio/casual already.
    var current = readCookie();
    if (!current) {
      current = readDefaultModeFromDom();
    }
    if (!current) {
      current = DEFAULT_MODE;
    }

    // Constrain the resolved mode to whatever this section enables.
    // If the visitor's stored preference is no longer offered (e.g.
    // they had 'runway' but this section disabled runway), drop them
    // back to the section's default. Don't persist this — they may
    // hit another section that does allow runway again.
    var enabled = readEnabledModesFromDom();
    if (enabled && enabled.indexOf(current) === -1) {
      var fallback = readDefaultModeFromDom();
      if (fallback && enabled.indexOf(fallback) !== -1) {
        current = fallback;
      } else {
        current = enabled[0];
      }
    }

    applyMode(current);

    document.addEventListener('click', onClick);

    lastScrollY = window.scrollY || window.pageYOffset || 0;
    updateFloatingVisibility();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
